import IconDownloadIcon from '@/components/common/icons/IconDownload'
import FormHeader from '@/components/layouts/form-layout/FormHeader'
import { Alert, Button } from '@dgshahr/ui-kit'
import { useButtonActionsContext } from '@/utils/contexts/form-layout/ButtonActionsContext'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import useAuthStore from '@/store/useAuthStore'
import { useSubmitContract } from '@/api/contract/PostContract'
import { useGetContracts } from '@/api/contract/GetContracts'

const ContractForm = () => {
  const { data } = useGetContracts({})

  const { setButtonActions } = useButtonActionsContext()
  const { setLastStep, contractType } = useAuthStore()
  const navigate = useNavigate()

  const { mutate, isPending: isPendingSubmitContract } = useSubmitContract({})

  const handlePrevStep = () => {
    navigate('/merchant-register/document-upload')
  }

  useEffect(() => {
    setButtonActions((prevState) => ({
      ...prevState,
      prevStepDisabled: false,
      nextStepDisabled: isPendingSubmitContract,
      nextStepIsLoading: isPendingSubmitContract,
      nextStepAction: () => {
        mutate(undefined, {
          onSuccess: () => {
            setLastStep(5)
            navigate('/merchant-register/status')
          }
        })
      },
      prevStepAction: handlePrevStep
    }))
  }, [setButtonActions, navigate, isPendingSubmitContract])

  const renderContractSection = () => {
    const isIndividual = contractType === 'individual'

    return (
      <div>
        <FormHeader title="مطالعه قرارداد و نحوه تسویه" />
        <div className="mt-5">
          <Alert
            className="tablet:!w-[460px] text-sm"
            text="لطفا نمونه قرارداد را دانلود و تا پایان فرایند بررسی مدارک‌تان مطالعه کنید."
          />
          {data?.categories_commission?.map((item) => (
            <div
              key={item.id}
              className="flex justify-between items-center bg-gray-50 border border-solid border-gray-200 rounded-lg p-4 my-3"
            >
              <p className="text-sm font-medium">{item.fa_name}</p>
              <Button
                rightIcon={<IconDownloadIcon />}
                variant="outline"
                onClick={() => {
                  const url = `/contract/preview?categoryId=${item.id}`
                  window.open(url, '_blank')
                }}
              >
                دانلود نمونه قرارداد{' '}
              </Button>
            </div>
          ))}
        </div>
      </div>
    )
  }

  return <>{renderContractSection()}</>
}

export default ContractForm
